import {createPortal} from 'react-dom'

const modalDivContainer = document.querySelector('#modals-root');
const PortalComponent = (props)=>{
    return createPortal(props.children,modalDivContainer);
}

export default PortalComponent;